export default {"src":"https://assets.getpocket.com/web-client/_next/static/media/firefox.82344ecc.svg","height":41,"width":41};